/* Product gallery — driven by window.productData set by product.liquid */
(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {
    if (!window.productData) return;

    var product = window.productData;
    var images = product.images || [];
    var variants = product.variants || [];

    var currentIndex = 0;
    var currentVariantId = variants.length ? variants[0].id : null;
    var qty = 1;

    /* Map variant id → its featured image index */
    var variantImageMap = {};
variants.forEach(function (v) {
  if (v.featured_image) {
    var featuredSrc = v.featured_image.src.split('?')[0];
    var idx = images.findIndex(function (img) {
      var imgSrc = (typeof img === 'string' ? img : (img.src || '')).split('?')[0];
      return imgSrc === featuredSrc;
    });
    if (idx > -1) variantImageMap[v.id] = idx;
  }
});

    function renderThumbs() {
      var strip = document.getElementById('thumb-strip');
      if (!strip) return;
      strip.innerHTML = '';
      images.forEach(function (img, i) {
        var div = document.createElement('div');
        div.className = 'thumb' + (i === 0 ? ' active' : '');
        div.dataset.index = i;
        div.onclick = (function (idx) { return function () { goToIndex(idx); }; })(i);
        var src = (typeof img === 'string' ? img : (img.src || img.url || '')).split('?')[0];
        div.innerHTML = '<img src="' + src + '" alt="' + (img.alt || '') + '" />';
        strip.appendChild(div);
      });
    }

    function showImage(idx) {
      var imgEl = document.getElementById('main-img');
      var phEl = document.getElementById('main-ph');
      if (!images.length) return;
      var src = (typeof images[idx] === 'string' ? images[idx] : (images[idx].src || images[idx].url || '')).split('?')[0];
      if (imgEl) {
        imgEl.style.opacity = '0';
        imgEl.src = src;
        imgEl.style.display = 'block';
        imgEl.onload = function () { imgEl.style.opacity = '1'; };
      }
      if (phEl) phEl.style.display = 'none';
    }

    function highlightThumb(idx) {
      document.querySelectorAll('#thumb-strip .thumb').forEach(function (t, i) {
        t.classList.toggle('active', i === idx);
      });
    }

    function scrollThumbToActive(idx) {
      var strip = document.getElementById('thumb-strip');
      if (!strip) return;
      var thumbs = strip.querySelectorAll('.thumb');
      if (thumbs[idx]) thumbs[idx].scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    }

    function updateCounter() {
      var el = document.getElementById('image-counter');
      if (!el || !images.length) return;
      el.textContent =
        String(currentIndex + 1).padStart(2, '0') + ' / ' +
        String(images.length).padStart(2, '0');
    }

    function applyThumbOverlay() {
      var strip = document.getElementById('thumb-strip');
      var mainWrap = document.querySelector('.main-image-wrap');
      if (!strip || !mainWrap) return;

      if (window.innerWidth <= 960) {
        strip.style.height = '';
        strip.querySelectorAll('.thumb-more').forEach(function (el) { el.remove(); });
        return;
      }

      var h = mainWrap.offsetHeight;
      strip.style.height = h + 'px';
      strip.querySelectorAll('.thumb-more').forEach(function (el) { el.remove(); });

      var thumbs = strip.querySelectorAll('.thumb');
      if (!thumbs.length) return;

      var thumbH = thumbs[0].offsetHeight;
      var gap = 8;
      var visibleCount = Math.floor((h + gap) / (thumbH + gap));
      var hiddenCount = thumbs.length - visibleCount;

      if (hiddenCount > 0 && visibleCount > 0) {
        var lastVisible = thumbs[visibleCount - 1];
        var overlay = document.createElement('div');
        overlay.className = 'thumb-more';
        overlay.textContent = '+' + hiddenCount;
        overlay.addEventListener('click', function (e) {
          e.stopPropagation();
          goToIndex(visibleCount);
        });
        lastVisible.appendChild(overlay);
      }
    }

    function goToIndex(idx) {
      currentIndex = idx;
      showImage(idx);
      updateCounter();
      highlightThumb(idx);
      scrollThumbToActive(idx);
      requestAnimationFrame(applyThumbOverlay);
    }

    /* Public API */
    window.navigate = function (dir) {
      if (!images.length) return;
      var total = images.length;
      goToIndex((currentIndex + dir + total) % total);
    };

    window.selectVariant = function (btn, variantId) {
      document.querySelectorAll('.size-btn').forEach(function (b) { b.classList.remove('active'); });
      btn.classList.add('active');
      currentVariantId = variantId;

      var variant = variants.find(function (v) { return v.id == variantId; });
      var sizeLabel = document.getElementById('size-label');
      if (sizeLabel && variant) sizeLabel.textContent = variant.option1;

      var variantInput = document.getElementById('variant-id-input');
      if (variantInput) variantInput.value = variantId;

      if (variantImageMap[variantId] !== undefined) {
        goToIndex(variantImageMap[variantId]);
      }
    };

    window.changeQty = function (delta) {
      qty = Math.max(1, qty + delta);
      var el = document.getElementById('qty-val');
      if (el) el.textContent = qty;
    };

    window.submitAddToCart = function () {
      if (!currentVariantId) {
        if (window.showToast) window.showToast('Please select a size');
        return;
      }
      if (window.addToShopifyCart) {
        window.addToShopifyCart(currentVariantId, qty);
      }
    };

    window.toggleAcc = function (bodyId, trigger) {
      var body = document.getElementById(bodyId);
      if (!body) return;
      var isOpen = body.classList.contains('open');
      document.querySelectorAll('.accordion-body').forEach(function (b) { b.classList.remove('open'); });
      document.querySelectorAll('.accordion-trigger').forEach(function (t) { t.classList.remove('open'); });
      if (!isOpen) { body.classList.add('open'); trigger.classList.add('open'); }
    };

    /* Init */
    renderThumbs();
    if (images.length) showImage(0);
    updateCounter();
    requestAnimationFrame(function () { requestAnimationFrame(applyThumbOverlay); });

    window.addEventListener('resize', applyThumbOverlay);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') window.navigate(-1);
      if (e.key === 'ArrowRight') window.navigate(1);
    });
  });
})();
